import type { ChangeEvent } from "react";
import Button from "../../../shared/components/elements/Button";
import InputField from "../../../shared/components/elements/InputField";
import type { AuthMode } from "../types";
import RecaptchaField from "../../../shared/components/elements/RecaptchaField";

interface DetailsStepProps {
    mode: AuthMode;
    name: string;
    phone: string;
    loading: boolean;
    captchaKey: number;
    onNameChange: (value: string) => void;
    onPhoneChange: (value: string) => void;
    onCaptchaChange: (token: string) => void;
    onSubmit: () => void;
}

// Step 1: name (register only), phone number and captcha
const DetailsStep = ({
                         mode,
                         name,
                         phone,
                         loading,
                         captchaKey,
                         onNameChange,
                         onPhoneChange,
                         onCaptchaChange,
                         onSubmit
                     }: DetailsStepProps) => {
    return (
        <>
            {mode === "register" && (
                <InputField
                    type="text"
                    title="نام"
                    className="mb-3"
                    value={name}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => onNameChange(e.target.value)}
                />
            )}

            <InputField
                type="tel"
                title="شماره تلفن همراه"
                className="mb-3"
                value={phone}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onPhoneChange(e.target.value)} name={undefined}
                disabled={undefined}            />

            <RecaptchaField resetKey={captchaKey} onChange={onCaptchaChange} />

            <Button onClick={onSubmit} className="mt-10 block" disabled={loading}>
                <span>{loading ? "در حال ارسال..." : "دریافت کد تایید"}</span>
            </Button>
        </>
    );
};

export default DetailsStep;